// extracted by mini-css-extract-plugin
export default {"copilotRedesignHeader":"f1FXIp","agentName":"lbXHgP"};